<app-header [fullMenu]="false"></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
